var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.paidFor)?_c('div',[_c('h4',{staticClass:"text-center text-success"},[_vm._v(" ¡Tu pago se ha completado correctamente! ")])]):_c('div',{ref:"paypal"})])
}
var staticRenderFns = []

export { render, staticRenderFns }